import React from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEllipsisH, faEye, faList, faPlus, faUser} from '@fortawesome/free-solid-svg-icons';
import {Button, ButtonGroup, Card, Col, Dropdown, Image, Row, Table} from '@themesberg/react-bootstrap';
import BasePage from "./../base/BasePage";
import label from "enqc-utilities/src/label/Label"
import PaginationTable from "../../components/PaginationTable";
import {getUser} from "../../utils/StorageUtil";
import {Link} from "react-router-dom";
import {Routes} from "../../routes";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import queryString from 'query-string';
import {navigate, navigatePage, pageNumber, parseDate, queryParams} from "enqc-utilities/src/utils/Utilities";
import {DD_MMMM_YYYY_HH_MM_SS} from "../../utils/Global";
import SearchInput from "../../components/input/SearchInput";
import TableSortOption from "../../components/input/TableSortOption";
import SortOption from "enqc-utilities/src/model/SortOption";
import MyImage from "../../components/MyImage";
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import ComponentAndRectifierInformationModal from "../../components/ComponentAndRectifierInformationModal";
import CreateAssemblyModal from "../../components/CreateAssemblyModal";
import CreateAssemblyConfirmationModal from "../../components/CreateAssemblyConfirmationModal";
import {toasting} from "../base/BaseComponent";
import AssemblyDetailPage from "../business/AssemblyDetailPage";
import ModelDetailInformationModal from "../../components/ModelDetailInformationModal";

class ModelPage extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      inputSearch: queryParams(this,props, 'search'),
      user : getUser(),
      createGoodsItemModal:{
        show:false,
        position:-1,
        model:{},
        goodsItems:[],
      },
      categorySelectorModal:false,
      componentAndRectifierInformationModal:false,
      createAssemblyModal:false,
      createAssemblyConfirmationModal:false,
      modelDetailInformationModal:false,
      selectedModel:{},
      inputReference:'',
      page: pageNumber(this.props),
      models:[],
      model:{},
      totalPage: 0,
      totalElement: 0,
      pageElement: 0,
      sortOption:SortOption.init(label.SelectOrder,"jt.partNumber",false)
    }
    // this.fetchModels()
  }

  componentDidMount() {
    super.componentDidMount();
      if(this.props?.navBar?.current){
          this.props.navBar.current.updateNavBarItems([ModelPage.PAGE_CONF])
      }
      this.closePreLoader()
     this.fetchModels()
  }

  componentWillReceiveProps(props, nextContext) {
    // if (props != this.props) {
      let {page, search} = this.state
      let newPage =  pageNumber(props)
      let newSearch = queryParams(props, 'search')
      let key = queryString.parse(props.query).tab ? queryString.parse(props.query).tab : label.All
      if(!newPage || !newSearch || page!==newPage || search!==newSearch){
        // alert("Test")
        this.setState({
          page: newPage,
          key: key,
          inputSearch: newSearch
        }, () => {
          this.fetchModels()
        })
      }
    // }
  }


  fetchModels = () => {
    let {user, models, search, sortOption} = this.state
    this.get(Endpoint.API.MODELS, {
      params :{
        userId : user.id,
        ascending: sortOption.ascending,
        sortir: sortOption.sortir,
        search: search,
        page: this.state.page - 1,
      }
    }, null, response=>{
      if(response.code===200){
        let models = response.data
        let totalPage = response.totalPage
        let totalElement = response.totalElement
        let pageElement = response.pageElement
        this.setState({models:models,totalPage, totalElement, pageElement})
      }else{
        this.props.history.goBack();
      }
    }, true, true)
  }



  render() {
    let {user, models, selectedModel, page, pageElement, totalPage, totalElement, sortOption,
        inputReference, componentAndRectifierInformationModal, createAssemblyModal, createAssemblyConfirmationModal, modelDetailInformationModal} = this.state
      return (
        <>
          {super.render()}
          <ComponentAndRectifierInformationModal
              show={componentAndRectifierInformationModal}
              onClose={() => {
                this.setState({componentAndRectifierInformationModal:false, selectedModel:{}})
              }}
              model={selectedModel}/>
          <CreateAssemblyModal
              {...this.props}
              show={createAssemblyModal}
              model={selectedModel}
              onClose={() => {
                this.setState({createAssemblyModal:false, selectedModel:{}})
              }}
              onResult={(reference, model) => {
                this.setState({createAssemblyModal:false, createAssemblyConfirmationModal:true, inputReference:reference, selectedModel:model})
              }}
          />
          <CreateAssemblyConfirmationModal
              {...this.props}
              show={createAssemblyConfirmationModal}
              reference={inputReference}
              model={selectedModel}
              onClose={() => {
                  this.setState({createAssemblyConfirmationModal:false, inputReference:'', selectedModel:{}})
              }}
              onResult={(assembly) => {
                  this.setState({createAssemblyConfirmationModal:false, inputReference:'', selectedModel:{}}, () => {
                      toasting.info(label.SuccessfullyUpdatingNewData)
                      navigate(this.props, AssemblyDetailPage.ENDPOINT+"?reference="+assembly.reference)
                  })
              }}
          />
          <ModelDetailInformationModal
              model={selectedModel}
              show={modelDetailInformationModal}
              onClose={() => {
                  this.setState({modelDetailInformationModal:false, selectedModel:{}})
              }}/>
            {this.renderHeader()}
            {this.renderDesktopTable()}
            {this.renderMobileList()}
            {this.renderEmpty()}
            <PaginationTable
                onSelect={(page) => {
                    this.setState({page}, () => {
                        navigatePage(this.props, page)
                    })
                }}
                showingRow={models.length}
                currentPage={page}
                pageCount={totalPage}
                totalElement={totalElement}/>
        </>
    );
  }
  renderHeader(){
      let {sortOption} = this.state
      return(
          <div className="table-settings ms-md-3 me-md-3">
              <Row className="align-items-center align-content-center">
                  <Col xs={4} sm={4} md={2} lg={1} xl={1} className="ps-md-0 text-left mb-2">
                      <TableSortOption
                          sortOptions={
                              [
                                  SortOption.init(label.PartNumber,"jt.partNumber",true),
                                  SortOption.init(label.SystemType,"jt.systemType",true),
                                  SortOption.init(label.Oldest,"jt.created",true),
                                  SortOption.init(label.Latest,"jt.created",false),
                              ]
                          }
                          sortOption={sortOption}
                          placeholder={label.SortBy}
                          onSelect={(sortOption) => {
                              this.setState({sortOption},() => {
                                  this.fetchModels()
                              })
                          }}
                          onReset={() => {
                              this.setState({sortOption:{}},() => {
                                  this.fetchModels()
                              })
                          }}/>
                  </Col>
                  <Col xs={12} sm={8} md={6} lg={4} xl={4} className="mb-2">
                      <SearchInput
                          placeholder={label.SearchModelByNameSystemAndPart}
                          onEnter={(search) => {
                              this.setState({search}, () => {
                                  this.fetchModels()
                              })
                          }} onEmpty={() => {
                          this.setState({search:""},() => {
                              this.fetchModels()
                          })
                      }}/>
                  </Col>
              </Row>
          </div>
      )
  }

    renderMobileList(){
        let {models, selectedModel, page, pageElement, totalPage, totalElement, componentAndRectifierInformationModal} = this.state
        if(!selectedModel){
            selectedModel = {}
        }
        return(
            <Card className="table-wrapper table-responsive d-block d-md-none bg-transparent border-0">
                {models.map((model, index)=>{
                    return(
                        <Card.Body
                            style={{backgroundColor:(index+1)%2>0?"#f5f1ea":"#ffffff", cursor:'pointer', border: '1px solid #dee2e6', borderRadius: '0.25rem' }}
                            className="p-0 mb-2">
                            <tr>
                                <td style={{whiteSpace:'nowrap', width:'8%'}} rowSpan="3" className="text-center align-items-center align-content-center fs-9 fw-bold text-white ps-2 pe-2 rounded-start bg-primary">
                                    #{((page - 1) * pageElement) + (index+1)}
                                </td>
                               <td colSpan={2} className="bg-white ps-2 pe-2 border-bottom">
                                   <div className="d-flex align-content-center align-items-center">
                                       <span className="text-left fw-bold text-success fs-7 p-0 w-100 d-inline-block">{model.modelName}</span>
                                       <span className="text-right font-italic fs-9 p-0 w-100 d-inline-block">{parseDate(model.updated, DD_MMMM_YYYY_HH_MM_SS)}</span>
                                   </div>
                               </td>
                            </tr>
                            <tr>
                                <td className="p-1" colSpan="2">
                                    <span className="fs-8 fw-bolder text-dark">{model.systemType}</span>
                                    <br/>
                                    <span className="fs-9 text-dark">{model.partName}</span>
                                </td>
                            </tr>
                            <tr>
                                <td className="text-left p-2" rowSpan="2">
                                    <span className="text-dark fs-7">{label.PN}:</span>
                                    <span className="text-italic text-info fw-bolder fs-7">{model.partNumber}</span>
                                </td>
                                <td className="text-right align-content-end align-items-end" style={{whiteSpace:'nowrap', width:'10%', padding:'10px'}}>
                                    <ButtonGroup>
                                        <Button
                                            size="sm"
                                            disabled={!model.applicable}
                                            onClick={event => {
                                                this.setState({
                                                    createAssemblyModal:true, selectedModel:model
                                                })
                                            }}>
                                            <FontAwesomeIcon size="sm" icon={faPlus} className="icon-dark" />
                                        </Button>
                                        <Dropdown as={ButtonGroup} drop={"right"}>
                                            <Dropdown.Toggle
                                                disabled={!model.applicable}
                                                size="sm"
                                                as={Button}
                                                split
                                                variant="outline-secondary"
                                                className="text-dark m-0 ps-1 pe-1">
                                                <span className="icon icon-sm"><FontAwesomeIcon size="sm" icon={faEllipsisH} className="icon-dark" /></span>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu size="sm" className="p-0" style={{marginRight:'180px'}}>
                                                <Dropdown.Item
                                                    onClick={
                                                        event => {
                                                            event.preventDefault()
                                                            this.setState({modelDetailInformationModal:true, selectedModel:model})
                                                        }}>
                                                    <FontAwesomeIcon size="sm" icon={faEye} className="me-2" />&nbsp;{label.Detail}
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    onClick={event => {
                                                        event.preventDefault()
                                                        componentAndRectifierInformationModal = true
                                                        selectedModel = model;
                                                        this.setState({componentAndRectifierInformationModal, selectedModel})
                                                    }}
                                                    size="sm">
                                                    <FontAwesomeIcon icon={faList} className="me-2" />&nbsp;{label.SeeAllItem}
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </ButtonGroup>
                                </td>
                            </tr>
                        </Card.Body>
                    )
                })}
            </Card>
        )
    }


    renderDesktopTable(){
      let {models, selectedModel, page, pageElement, totalPage, totalElement, componentAndRectifierInformationModal} = this.state
      return(
          <Card border="light" className="table-wrapper table-responsive shadow-sm d-none d-sm-block">
              <Card.Body className="p-0">
                  <Table hover className="table-sm align-items-center">
                      <thead>
                      <tr className="bg-light">
                          <th className="border-bottom">#</th>
                          <th className="border-bottom">{label.Category}/{label.Name}/{label.PartNumber}</th>
                          <th className="border-bottom">{label.Image}</th>
                          <th className="border-bottom text-center">{label.ComponentAndRectifier}</th>
                          <th className="border-bottom">{label.Status}</th>
                          <th className="border-bottom">{label.Created}</th>
                          <th className="border-bottom text-center">{label.AssemblyOrAction}</th>
                      </tr>
                      </thead>
                      <tbody>
                      {models.map((model, index) => (
                          <tr key={index}>
                              <td>
                                  <Card.Link as={Link} to={Routes.Invoice.path} className="fw-normal">
                                      {((page - 1) * pageElement) + (index+1)}
                                  </Card.Link>
                              </td>
                              <td className="text-wrap">
                                  <span className="font-italic text-underline fw-bold">{model.modelCategory?model.modelCategory.name:""}</span>
                                  <br/>
                                  <span className="fw-normal text-info">
                            {model.name}
                        </span>
                                  <br/>
                                  <span className="fw-normal text-danger text-italic text-underline">
                        {model.partNumber}
                        </span>
                              </td>
                              <td>
                                  <MyImage
                                      style={{width:'40px'}}
                                      src={model.iconPhotoUrl}
                                      defaultImage={ApplicationIcons.Icons.noImage}
                                      onClick={(e)=>{
                                          e.preventDefault()
                                          this.openLightBox(model.iconPhotoUrl)
                                      }}
                                  />
                              </td>
                              <td className="text-center"><span className="fw-normal">
                        <Button
                            className="btn-light text-dark"
                            variant="outline-info"
                            size="sm"
                            onClick={event => {
                                componentAndRectifierInformationModal = true
                                selectedModel = model;
                                this.setState({componentAndRectifierInformationModal, selectedModel})
                            }}>
                          {model.componentSize} / {model.sizeOfRectifierControllerSerialNumber} &nbsp;
                            <FontAwesomeIcon size="sm" icon={faList} className="icon-dark" />
                        </Button>
                      </span>
                              </td>
                              <td>
                                  <Button
                                      size="sm"
                                      variant="white"
                                      className={"bg-white fw-normal "+(model.applicable?"text-success btn-outline-success":"text-danger btn-outline-danger")}
                                      onClick={event => {}}>
                                      {model.applicable?label.Active:label.Inactive}
                                  </Button>
                              </td>
                              <td>
                                  <span className="fw-normal">{parseDate(model.created, DD_MMMM_YYYY_HH_MM_SS)}</span>
                              </td>
                              <td className="text-center">
                                  <ButtonGroup>
                                      <Button
                                          size="sm"
                                          disabled={!model.applicable}
                                          onClick={event => {
                                              this.setState({
                                                  createAssemblyModal:true, selectedModel:model
                                              })
                                          }}>
                                          <FontAwesomeIcon size="sm" icon={faPlus} className="icon-dark" />
                                      </Button>
                                      <Dropdown as={ButtonGroup} drop={"right"}>
                                          <Dropdown.Toggle
                                              disabled={!model.applicable}
                                              size="sm"
                                              as={Button}
                                              split
                                              variant="outline-secondary"
                                              className="text-dark m-0 ps-1 pe-1">
                                            <span className="icon icon-sm"><FontAwesomeIcon size="sm" icon={faEllipsisH} className="icon-dark" /></span>
                                          </Dropdown.Toggle>
                                          <Dropdown.Menu size="sm" className="p-0" style={{marginRight:'180px'}}>
                                              <Dropdown.Item
                                                  onClick={
                                                  event => {
                                                      event.preventDefault()
                                                  this.setState({modelDetailInformationModal:true, selectedModel:model})
                                              }}>
                                                  <FontAwesomeIcon size="sm" icon={faEye} className="me-2" />&nbsp;{label.Detail}
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                  onClick={event => {
                                                      event.preventDefault()
                                                      componentAndRectifierInformationModal = true
                                                      selectedModel = model;
                                                      this.setState({componentAndRectifierInformationModal, selectedModel})
                                                  }}
                                                  size="sm">
                                                  <FontAwesomeIcon icon={faList} className="me-2" />&nbsp;{label.SeeAllItem}
                                              </Dropdown.Item>
                                          </Dropdown.Menu>
                                      </Dropdown>
                                  </ButtonGroup>
                              </td>
                          </tr>
                      ))}
                      </tbody>
                  </Table>
              </Card.Body>
          </Card>
      )
  }
    renderEmpty(){
        let {models}= this.state
        if(!models){
            models = []
        }

        if(models.length<=0){
            return (
                <Card className="mb-3">
                    <Card.Body>
                        <div className="w-100 h-100 text-center align-content-center justify-content-center align-items-center" style={{minHeight:'200px'}}>
                            <Image
                                className="p-1"
                                style={{
                                    width: '150px',
                                    height: '150px',
                                    objectFit: 'cover',
                                    opacity: 0.2,
                                    filter : 'blur(1px)'
                                }}
                                src={ApplicationIcons.Icons.emptyBox}/>
                            <br/>
                            <span>Empty data..</span>
                        </div>
                    </Card.Body>
                </Card>
            )
        }
        return(null)
    }

}
// export default Object.assign(ModelPage, {ENDPOINT : "/model"})

const ENDPOINT = "/models"
const TITLE = label.Models
const PAGE = {ENDPOINT: ENDPOINT, PAGE_CONF: {ENDPOINT, TITLE}}
export default Object.assign(ModelPage, PAGE)


